import React from 'react';
import { getFieldValue } from '@sitecore-jss/sitecore-jss-react';
import { Container, Section } from 'components/shared';
import styled from 'styled-components';
import { isValidTitle } from 'utils/validateTitle';

import loadable from '@loadable/component';
const LargeTitleAndText = loadable(() =>
  import('components/components/molecules/LargeTitleAndText'),
);

const StyledSection = styled(Section)`
  padding-bottom: 0.625rem !important;
`;

const LargeTitleAndTextContainer = ({ fields }) => {
  const title = getFieldValue(fields, 'title');
  const text = getFieldValue(fields, 'text');
  const textAlignment = getFieldValue(fields, 'textAlignment');
  const date = getFieldValue(fields, 'date') || '';

  if (!isValidTitle(title) && !text) {
    return null;
  }

  return (
    <StyledSection>
      <Container>
        <span className='flex flex-col h-full w-full font-graphie text-normal text-action-blue font-bold pb-2 md:pb-3'>
          {date}
        </span>
        <LargeTitleAndText
          title={title}
          text={text}
          textAlignment={textAlignment}
        />
      </Container>
    </StyledSection>
  );
};

export default LargeTitleAndTextContainer;
